// main.js


(function () {
 try {
   /* main variables */
   var debug = 0;
   var variation_name = "";
   var $;


   /* all Pure helper functions */
   function waitForElement(selector, trigger, delayInterval, delayTimeout) {
     var interval = setInterval(function () {
       if (
         document &&
         document.querySelector(selector) &&
         document.querySelectorAll(selector).length > 0
       ) {
         clearInterval(interval);
         trigger();
       }
     }, delayInterval);


     setTimeout(function () {
       clearInterval(interval);
     }, delayTimeout);
   }


   function init() {
     if (document.querySelector(".cg-filter-external-style")) return;


     document.body.classList.add("EG-FILTER");


     (() => {
       const allowed = ["größe", "farbe", "preis"];
       let openFilter = null;
       let isApplyingLayout = false;


       const filterWidth = 101;
       const filterHeight = 40;
       const filterFontSize = 16.5;
       const dropdownTop = 48;
       const gap = 11;


       function labelOf(item) {
         return (
           item
             ?.querySelector(".js-accordion-control")
             ?.innerText?.trim()
             ?.toLowerCase() || ""
         );
       }


       function updateBodyDropdownClass() {
         document
           .querySelectorAll(".js-accordion-filter-item")
           .forEach((item) => {
             const dropdown = item.querySelector(
               ".js-accordion-content"
             );


             item.classList.toggle(
               "dd-open",
               dropdown?.classList.contains("cg-dropdown-open")
             );
           });
       }


       function closeDropdowns() {
         openFilter = null;


         document
           .querySelectorAll("#filterMenuDrawer .js-accordion-content")
           .forEach((el) => {
             el.classList.remove("cg-dropdown-open");
           });


         updateBodyDropdownClass();
       }


       function findHeadlineSection(headline) {
         return (
           headline.closest(".collection__header") ||
           headline.closest(".collection-hero") ||
           headline.closest(".page-width") ||
           headline.parentElement
         );
       }


       function getCopyElement(headlineSection, headline) {
         return (
           headlineSection?.querySelector("p") ||
           headline.nextElementSibling ||
           headline
         );
       }


       function getHeaderElement() {
         return (
           document.querySelector("header") ||
           document.querySelector(".shopify-section-header") ||
           document.querySelector(".site-header") ||
           document.querySelector(".header-wrapper")
         );
       }


       function updateStickyTop() {
         const header = getHeaderElement();


         if (!header) {
           document.documentElement.style.setProperty(
             "--cg-sticky-filter-top",
             "0px"
           );
           return;
         }


         const rect = header.getBoundingClientRect();
         const visibleHeight = Math.max(0, Math.round(rect.bottom));


         document.documentElement.style.setProperty(
           "--cg-sticky-filter-top",
           `${visibleHeight}px`
         );
       }


       function buildActiveFilterPills(filterBar) {
         let pillWrapper = filterBar.querySelector(
           ".cg-active-filter-pills"
         );


         if (!pillWrapper) {
           pillWrapper = document.createElement("div");
           pillWrapper.className = "cg-active-filter-pills";
           filterBar.prepend(pillWrapper);
         }


         pillWrapper.innerHTML = "";


         const originalItems = [
           ...document.querySelectorAll(
             ".product-filters__form-selected-button.js-remove-filter"
           ),
         ];


         if (!originalItems.length) {
           pillWrapper.style.display = "none";
           return;
         }


         pillWrapper.style.display = "flex";


         originalItems.forEach((original) => {
           const text = original.innerText.trim();


           if (!text) return;


           const pill = document.createElement("a");


           pill.href = original.href || "#";
           pill.innerHTML = text;
           pill.className = "cg-filter-pill";


           pill.addEventListener("click", (e) => {
             e.preventDefault();


             closeDropdowns();


             if (original.href) {
               window.location.href = original.href;
             } else {
               original.click();
             }
           });


           pillWrapper.appendChild(pill);
         });
       }


       function applyLayout() {
         if (isApplyingLayout) return;


         isApplyingLayout = true;


         updateStickyTop();


         const filterBar = document.querySelector("#filterMenuDrawer");


         const productGrid =
           document.querySelector(".collection__grid-wrapper") ||
           document.querySelector(".collection__body");


         const headline = document.querySelector("h1");


         if (!filterBar || !productGrid || !headline) {
           isApplyingLayout = false;
           return;
         }


         const isMobile = window.innerWidth <= 768;


         const headlineSection = findHeadlineSection(headline);


         const copy = getCopyElement(headlineSection, headline);


         if (!copy || typeof copy.getBoundingClientRect !== "function") {
           isApplyingLayout = false;
           return;
         }


         const copyRect = copy.getBoundingClientRect();


         const filterLeft = isMobile ? 20 : Math.round(copyRect.left);


         const filterRight = isMobile ? 20 : 70;


         if (headlineSection && headlineSection.parentNode) {
           headlineSection.parentNode.insertBefore(
             filterBar,
             headlineSection.nextSibling
           );
         } else {
           productGrid.parentNode.insertBefore(filterBar, productGrid);
         }


         filterBar.hidden = false;
         filterBar.removeAttribute("aria-hidden");


         filterBar.style.display = "block";


         buildActiveFilterPills(filterBar);


         document
           .querySelectorAll(`
           .drawer__header,
           .drawer__close,
           .js-filter-menu-opener,
           .js-filter-menu-opener-wrapper,
           .product-filters__header,
           .product-filters__form-sort,
           .product-filters__form-footer,
           .product-filters__form-label
         `)
           .forEach((el) => {
             el.classList.add("cg-hidden");
           });


         filterBar
           .querySelectorAll(`
           .product-filters__form,
           .product-filters__form-body
         `)
           .forEach((el) => {
             el.classList.add("cg-filter-form");
           });


         const accordion = filterBar.querySelector(
           ".product-filters__form-accordion"
         );


         if (accordion) {
           accordion.style.setProperty(
             "--cg-filter-width",
             `calc(100vw - ${filterLeft}px - ${filterRight}px)`
           );


           accordion.style.setProperty(
             "--cg-filter-left",
             `${filterLeft}px`
           );


           accordion.style.setProperty(
             "--cg-filter-right",
             `${filterRight}px`
           );


           accordion.style.setProperty("--cg-gap", `${gap}px`);


           accordion.classList.add("cg-filter-accordion");
         }


         filterBar
           .querySelectorAll(".js-accordion-filter-item")
           .forEach((item) => {
             const label = labelOf(item);


             const index = allowed.findIndex((v) =>
               label.includes(v)
             );


             if (index === -1) {
               item.classList.add("cg-hidden");
               return;
             }


             item.style.order = index;
             item.style.setProperty(
               "--cg-filter-item-width",
               `${filterWidth}px`
             );


             item.classList.add("cg-filter-item");
           });


         filterBar
           .querySelectorAll(".js-accordion-control")
           .forEach((button) => {
             const bubble = button.querySelector(".cg-filter-bubble");
             if (bubble) {
               bubble.remove();
             }


             button.style.setProperty(
               "--cg-filter-height",
               `${filterHeight}px`
             );


             button.style.setProperty(
               "--cg-filter-font-size",
               `${filterFontSize}px`
             );


             button.style.setProperty(
               "--cg-filter-width",
               `${filterWidth}px`
             );


             button.classList.add("cg-filter-button");
           });


         filterBar
           .querySelectorAll(".js-accordion-content")
           .forEach((content) => {
             const item =
               content.closest(".js-accordion-filter-item");


             const label = labelOf(item);


             const isOpen =
               openFilter && label.includes(openFilter);


             content.style.setProperty(
               "--cg-dropdown-top",
               `${dropdownTop}px`
             );


             content.classList.add("cg-filter-dropdown");


             if (isOpen) {
               content.classList.add("cg-dropdown-open");
             } else {
               content.classList.remove("cg-dropdown-open");
             }
           });


         updateBodyDropdownClass();


         setTimeout(() => {
           isApplyingLayout = false;
         }, 0);
       }


       document.addEventListener(
         "click",
         (e) => {
           const filterBar =
             document.querySelector("#filterMenuDrawer");


           if (!filterBar) return;


           const button = e.target.closest(
             ".js-accordion-control"
           );


           const contentClick = e.target.closest(
             ".js-accordion-content"
           );


           if (button && filterBar.contains(button)) {
             e.preventDefault();
             e.stopImmediatePropagation();


             const item = button.closest(
               ".js-accordion-filter-item"
             );


             const content =
               item?.querySelector(".js-accordion-content");


             const label = labelOf(item);


             const matchedLabel = allowed.find((v) =>
               label.includes(v)
             );


             if (!content || !matchedLabel) return;


             const isOpen = openFilter === matchedLabel;


             closeDropdowns();


             if (!isOpen) {
               openFilter = matchedLabel;
               content.classList.add("cg-dropdown-open");
             }


             updateBodyDropdownClass();


             return;
           }


           if (contentClick && filterBar.contains(contentClick)) {
             return;
           }


           if (!filterBar.contains(e.target)) {
             closeDropdowns();
           }
         },
         true
       );


       window.addEventListener(
         "scroll",
         () => {
           requestAnimationFrame(updateStickyTop);
         },
         { passive: true }
       );


       window.addEventListener("resize", () => {
         clearTimeout(window.__filterResizeFix);


         window.__filterResizeFix = setTimeout(
           applyLayout,
           150
         );
       });


       const observerTarget = document.querySelector(".collection__grid-wrapper") || document.querySelector(".collection__body");


       if (observerTarget) {
         const observer = new MutationObserver((mutations) => {
           if (isApplyingLayout) return;


           let selfMutated = mutations.some(mut => {
             const target = mut.target;
             return (
               target.id === 'filterMenuDrawer' ||
               target.closest('#filterMenuDrawer') ||
               target.classList?.contains('cg-hidden') ||
               target.classList?.contains('cg-filter-form')
             );
           });


           if (selfMutated) return;


           clearTimeout(window.__filterFix);
           window.__filterFix = setTimeout(() => {
             applyLayout();
           }, 250);
         });


         observer.observe(observerTarget, {
           childList: true,
           subtree: true
         });
       } else {
         new MutationObserver(() => {
           if (isApplyingLayout) return;
           clearTimeout(window.__filterFix);
           window.__filterFix = setTimeout(applyLayout, 250);
         }).observe(document.body, {
           childList: true,
           subtree: false
         });
       }


       applyLayout();


       console.log(
         "Sticky filter fixed: dropdowns stay open and body gets dd-open class."
       );
     })();
   }


   /* Initialize variation */
   waitForElement(
     "#filterMenuDrawer .js-accordion-content",
     init,
     50,
     15000
   );
 } catch (e) {
   if (debug) console.log(e, "error in Test" + variation_name);
 }
})();
